<template>
  <PublicLayout>
    <h1 class="public__title">Mentions légales</h1>
    <p class="public__lead">
     La présente politique de confidentialité décrit la manière dont les données personnelles sont collectées et traitées lors de l'utilisation de l'application web Saineo. Mise à jour : 08/03/2026.
    </p>

    <h2 class="public__section-title">1. Responsable du traitement</h2>
    <p class="public__text">
            Le responsable du traitement est :
      <br /><br />
      Wided Oueslati<br />
      BUREAU 326<br />
      78 AVENUE DES CHAMPS ELYSEES<br />
      75008 PARIS – France<br />
      <br />
      Email : contact@saineo.eu
    </p>

    <h2 class="public__section-title">2. Présentation du service</h2>
    <p class="public__text">
      Saineo est une application web accessible depuis un navigateur internet (ordinateur, smartphone ou tablette) permettant aux utilisateurs d'obtenir des recommandations nutritionnelles personnalisées.
      <br /><br />
      L'application propose des suggestions alimentaires adaptées aux préférences, objectifs et informations renseignées par les utilisateurs.
    </p>

    <h2 class="public__section-title">3. Données personnelles collectées</h2>
    <p class="public__text">
      <strong>3.1 Données de compte</strong><br /><br />
      Lors de la création d'un compte utilisateur, les informations suivantes sont collectées :<br />
      adresse email<br />
      mot de passe (stocké sous forme chiffrée)<br />
      <br />
      Ces données permettent la création et la gestion du compte utilisateur.
    </p>

    <p class="public__text">
      <strong>3.2 Données de profil et de mode de vie</strong><br /><br />
      Afin de personnaliser les recommandations nutritionnelles, l'utilisateur peut renseigner :<br />
      tranche d'âge<br />
      genre<br />
      poids<br />
      taille<br />
      métier<br />
      niveau d'activité quotidienne (assis, debout, actif)<br />
      nombre moyen de pas par jour<br />
      nombre de séances de sport par semaine<br />
      statut d'athlète de haut niveau<br />
      consommation de viande<br />
      consommation d'alcool<br />
      nombre de repas par jour<br />
      objectifs nutritionnels<br />
      objectifs secondaires (par exemple améliorer la digestion)
    </p>

    <p class="public__text">
      <strong>3.3 Données alimentaires et préférences</strong><br /><br />
      Les utilisateurs peuvent également indiquer :<br />
      leur régime alimentaire (vegan, végétarien, etc.)<br />
      leurs restrictions alimentaires religieuses (halal, casher, etc.)<br />
      leurs préférences alimentaires<br />
      les enseignes de supermarchés qu'ils fréquentent habituellement.<br />
      <br />
      Ces informations permettent d'adapter les recommandations alimentaires proposées dans l'application.
    </p>

    <p class="public__text">
      <strong>3.4 Données de santé (facultatives)</strong><br /><br />
      Certains utilisateurs peuvent choisir de renseigner volontairement des informations liées à leur santé, notamment :<br />
      allergies alimentaires<br />
      intolérances alimentaires<br />
      pathologies (par exemple diabète, troubles thyroïdiens, hypertension)<br />
      grossesse<br />
      allaitement.<br />
      <br />
      Ces informations sont facultatives et sont fournies uniquement par l'utilisateur afin d'améliorer la pertinence des recommandations nutritionnelles.
    </p>

    <h2 class="public__section-title">4. Finalités du traitement</h2>
    <p class="public__text">
      Les données personnelles sont utilisées pour :<br />
      créer et gérer les comptes utilisateurs<br />
      personnaliser les recommandations nutritionnelles<br />
      adapter les contenus proposés dans l'application<br />
      améliorer les fonctionnalités et les performances du service<br />
      assurer la sécurité et le bon fonctionnement de la plateforme.
    </p>

    <h2 class="public__section-title">5. Base légale du traitement</h2>
    <p class="public__text">
      Les données personnelles sont traitées sur les bases juridiques suivantes :<br />
      exécution du service pour permettre le fonctionnement de l'application<br />
      consentement de l'utilisateur pour les données sensibles (données de santé)<br />
      intérêt légitime pour l'amélioration du service.
    </p>

    <h2 class="public__section-title">6. Outils et prestataires utilisés</h2>
    <p class="public__text">
      Afin de fournir le service, Saineo utilise certains prestataires techniques.
      <br /><br />
      <strong>Hébergement et infrastructure</strong><br />
      L'application utilise les services de Firebase, fournis par Google, notamment :<br />
      Firebase Authentication (gestion des comptes)<br />
      Firestore / Realtime Database (stockage des données)<br />
      Firebase Analytics (analyse d'utilisation)<br />
      <br />
      Ces services peuvent impliquer un traitement de données sur des serveurs situés dans l'Union européenne ou aux États-Unis.
    </p>

    <h2 class="public__section-title">7. Sécurité des données</h2>
    <p class="public__text">
      Saineo met en œuvre des mesures techniques et organisationnelles raisonnables afin de protéger les données personnelles contre :<br />
      l'accès non autorisé,<br />
      la perte,<br />
      la destruction,<br />
      la divulgation.
    </p>

    <h2 class="public__section-title">8. Durée de conservation</h2>
    <p class="public__text">
      Les données personnelles sont conservées pendant la durée d'utilisation du service.<br />
      En cas de suppression du compte, les données sont effacées dans un délai raisonnable.
    </p>

    <h2 class="public__section-title">9. Paiement</h2>
    <p class="public__text">
      Des services de paiement pourront être proposés via Stripe afin de gérer les abonnements à l'application.<br />
      Dans ce cas, les données de paiement sont traitées directement par Stripe et ne sont pas stockées par Saineo.
    </p>

    <h2 class="public__section-title">10. Utilisation par des mineurs</h2>
    <p class="public__text">
      Le service Saineo est réservé aux personnes âgées de 18 ans ou plus.<br />
      Les personnes mineures ne sont pas autorisées à créer un compte.
    </p>

    <h2 class="public__section-title">11. Droits des utilisateurs</h2>
    <p class="public__text">
      Conformément au Règlement général sur la protection des données, les utilisateurs disposent des droits suivants :<br />
      droit d'accès aux données<br />
      droit de rectification<br />
      droit d'effacement<br />
      droit de limitation du traitement<br />
      droit d'opposition<br />
      droit à la portabilité des données.<br />
      <br />
      Toute demande peut être adressée à : contact@saineo.eu
    </p>

    <h2 class="public__section-title">12. Modification de la politique</h2>
    <p class="public__text">
      Saineo se réserve le droit de modifier la présente politique de confidentialité à tout moment afin de refléter les évolutions du service ou les obligations légales.<br />
      La date de mise à jour sera indiquée sur cette page.
    </p>

  </PublicLayout>
</template>

<script>
import PublicLayout from './PublicLayout.vue';

export default {
  name: 'LegalPage',
  components: { PublicLayout },
};
</script>
